<template>
    <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="场站大类：">
            <el-select style="width: 100px;" v-model="formInline.type" filterable placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option
                v-for="item in stationOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="场站状态：">
            <el-select style="width: 100px;" v-model="formInline.state" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
            <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="合作方：">
            <el-select style="width: 200px;" v-model="searchPartners" multiple clearable placeholder="请选择合作方" collapse-tags collapse-tags-tooltip>
                <el-option
                    v-for="item in partnerList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="运营时间：">
            <el-date-picker
                v-model="formInline.date"
                value-format="YYYY-MM-DD"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
            />
        </el-form-item>
        <el-form-item label="省市区：" style="display: none;">
            <elui-china-area-dht v-model="areaSelect" isall :leave="3" :placeholder="['选择省市区']" @change="onChange"></elui-china-area-dht>
        </el-form-item>
        <el-form-item label="关键字：">
            <el-input v-model="formInline.name" placeholder="请输入场站名称"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
            <el-button type="success" @click="openAdd">新增</el-button>
            <el-button @click="exportData">导出</el-button>
        </el-form-item>
    </el-form>

    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
     <el-table-column label="场站ID" width="80">
        <template #default="scope">
          <div>
            <span>{{ scope.row.id }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="场站名称" width="180" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="场站编码" width="180" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.code }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="场站大类">
        <template #default="scope">
          <div>
            <span>{{typeFilter(scope.row.type)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="场站状态">
        <template #default="scope">
          <div>
            <span>{{statusFilter(scope.row.state)}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="桩数量">
        <template #default="scope">
          <div>
            <span>{{scope.row.pileNumber}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="140" label="充电枪数量">
        <template #default="scope">
          <div style="line-height: 1.8;">
            <div>{{ scope.row.gunNumber || 0 }}/{{ scope.row.gunOnlineNumber || 0 }}/{{ scope.row.gunOfflineNumber || 0 }}</div>
            <div style="color: #909399; font-size: 12px;">(总数/在线/离线)</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="140" label="充电枪状态">
        <template #default="scope">
          <div style="line-height: 1.8;">
            <div>{{ scope.row.gunFreeNumber || 0 }}/{{ scope.row.gunChargingNumber || 0 }}/{{ scope.row.gunFaultNumber || 0 }}</div>
            <div style="color: #909399; font-size: 12px;">(空闲/充电/故障)</div>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column width="140" label="投资成本">
        <template #default="scope">
          <div>
            <span>{{scope.row.investmentCost || '--'}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="180" label="预计回本周期（月）">
        <template #default="scope">
          <div>
            <span>{{scope.row.paybackPeriod || '--'}}</span>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column label="起始运营日期" width="200">
            <template #default="scope">
            <div>
                <span>{{ scope.row.openingTime || '--' }}</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column label="合作方" width="200" show-overflow-tooltip>
            <template #default="scope">
            <div>
                <span>{{ partnerFilter(scope.row.stationPartners) }}</span>
            </div>
            </template>
        </el-table-column>
      <!-- <el-table-column width="140" label="充电桩状态(空闲/充电/故障)" show-overflow-tooltip="true">
        <template #default="scope">
          <div>
            <span>{{scope.row.gunStatus}}</span>
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="可见性">
        <template #default="scope">
          <div>
            <span>{{showFilter(scope.row.show)}}</span>
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="创建时间" width="180">
        <template #default="scope">
          <div>
            <span>{{ scope.row.createTime }}</span>
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="运营参数" width="120">
        <template #default="scope">
            <el-button size="small" @click="openOperation(scope.$index, scope.row)">
            设置运营参数
          </el-button>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="380" fixed="right">
        <template #default="scope">
            <el-button size="small" type="primary" @click="showInfo(scope.$index, scope.row)">
            查看
          </el-button>
          <el-button size="small" type="primary" @click="showDialogForm(scope.$index, scope.row)">
            配置合作方
          </el-button>
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-button size="small" type="warning" @click="getMoniData(scope.$index, scope.row)">
            监控
          </el-button>
          <el-button
            size="small"
            type="danger"
            @click="deleteStation(scope.$index, scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 对话框--合作方配置 -->
    <el-dialog v-model="dialogFormVisible" title="合作方配置" width="500" :close-on-click-modal="false">
        <el-form label-position="right" label-width="auto" :model="partnerInfo">
            <el-form-item label="合作方">
                <el-select v-model="selectedPartners" multiple clearable placeholder="请选择合作方" collapse-tags collapse-tags-tooltip>
                <el-option
                    v-for="item in partnerList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="saveConfig()">确定</el-button>
        </div>
        </template>
    </el-dialog>
    
    <!-- 新增场站 -->
    <el-drawer
        v-model="drawer"
        :title="drawerTitle"
        size="45%"
        direction="rtl"
        :before-close="handleClose"
        @closed="$refs.stationFormRef?.clearValidate()"
    >
    <el-form ref="stationFormRef" :model="stationInfo" :rules="stationRules" label-position="right" label-width="auto">
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="场站名称：" prop="name">
                <el-input v-model="stationInfo.name" maxlength="30" autocomplete="off" :readonly="isReadonly" />
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="简称：" prop="shortName" label-width='82'>
                <el-input v-model="stationInfo.shortName" maxlength="30" autocomplete="off" :readonly="isReadonly" />
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="场站编码：" prop="code">
                <el-input v-model="stationInfo.code" maxlength="30" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="场站状态：" prop="" label-width='82'>
                <el-select v-model="stationInfo.state" placeholder="请选择场站状态">
                    <el-option label="建设中" :value="1" />
                    <el-option label="运营中" :value="2" />
                    <el-option label="未供电" :value="3" />
                    <el-option label="关闭下线" :value="4" />
                </el-select>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="场站大类：" prop="">
                    <el-select v-model="stationInfo.type" placeholder="请选择场站大类">
                        <el-option label="高速" :value="1" />
                        <el-option label="市区" :value="2" />
                        <el-option label="内部" :value="3" />
                        <el-option label="社区" :value="4" />
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="场站类型：" prop="">
                    <el-select v-model="stationInfo.evnType" placeholder="请选择场站类型">
                        <el-option label="公共" :value="1" />
                        <el-option label="个人" :value="2" />
                        <el-option label="公交专用" :value="3" />
                        <el-option label="环卫专用" :value="4" />
                        <el-option label="物流专用" :value="5" />
                        <el-option label="出租车专用" :value="6" />
                        <el-option label="其他" :value="20" />
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="建设场所：" prop="">
                    <el-select v-model="stationInfo.constructionSite" placeholder="请选择建设场所">
                        <el-option label="居民楼" :value="1" />
                        <el-option label="公共机构" :value="2" />
                        <el-option label="企事业单位" :value="3" />
                        <el-option label="写字楼" :value="4" />
                        <el-option label="工业园区" :value="5" />
                        <el-option label="交通枢纽" :value="6" />
                        <el-option label="大型文体设施" :value="7" />
                        <el-option label="城市绿地" :value="8" />
                        <el-option label="大型建筑配建停车场" :value="9" />
                        <el-option label="路边停车位" :value="10" />
                        <el-option label="城际高速服务区" :value="11" />
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="地上地下：" prop="">
                    <el-select v-model="stationInfo.upOrDown" placeholder="请选择地上地下">
                        <el-option label="地上" :value="1" />
                        <el-option label="地下" :value="2" />
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="运营模式：" prop="">
                    <el-radio-group v-model="stationInfo.mode">
                        <el-radio :value="1">自营</el-radio>
                        <el-radio :value="2">合作</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="场站面积：" prop="">
                <el-input v-model="stationInfo.buildingArea" type="number" maxlength="20" autocomplete="off" :readonly="isReadonly">
                    <template #append>m²</template>
                </el-input>
                </el-form-item>
            </el-col>
        </el-row>
        
        
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="场站负责人：" prop="stationManager">
                <el-input v-model="stationInfo.stationManager" maxlength="20" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="联系电话：" prop="servicePhone">
                <el-input v-model="stationInfo.servicePhone" maxlength="20" autocomplete="off" :readonly="isReadonly" placeholder="手机号或座机号"/>
                </el-form-item>
            </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="场站面积：" prop="">
                <el-input v-model="stationInfo.stationArea" type="number" maxlength="20" autocomplete="off" :readonly="isReadonly">
                    <template #append>m²</template>
                </el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="设备电容量：" prop="">
                <el-input v-model="stationInfo.totalPower" type="number" maxlength="20" autocomplete="off" :readonly="isReadonly">
                    <template #append>KW</template>
                </el-input>
                </el-form-item>
            </el-col>
        </el-row> -->
        <el-row :gutter="20">
            <!-- <el-col :span="12">
                <el-form-item label="客服电话：" prop="">
                <el-input v-model="stationInfo.servicePhone" type="number" maxlength="20" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col> -->
            <el-col :span="12">
                <el-form-item label="设备电容量：" prop="">
                <el-input v-model="stationInfo.totalPower" type="number" maxlength="20" autocomplete="off" :readonly="isReadonly">
                    <template #append>KW</template>
                </el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="开业时间：" prop="">
                <!-- <el-input v-model="stationInfo.openingTime" maxlength="30" autocomplete="off" :readonly="isReadonly"/> -->
                <el-date-picker
                    v-model="stationInfo.openingTime"
                    type="datetime"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    placeholder="选择开业时间"
                >
                </el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-form-item label="配套设施：">
                    <el-checkbox-group v-model="from_facilities" @change="handleCheckedCitiesChange">
                        <el-checkbox v-for="city in cities" :label="city.label" :value="city.value" :key="city.value">{{city.label}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-form-item label="场站照片：">
                    <el-upload
                        :action="uploadUrl"
                        :headers="headers"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                        list-type="picture-card"
                        limit="3"
                        :file-list="imgList"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove">
                        <i class="el-icon-plus">+</i>
                    </el-upload>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="充电车位：" prop="">
                <el-input v-model="stationInfo.carNumber" maxlength="6" autocomplete="off">
                    <template #append>个</template>
                </el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form-item label="省市区：" prop="">
                    <el-cascader
                        style="width: 100%;"
                        v-model="stationInfo.addrCode"
                        :options="areaOptions"
                        placeholder="请选择省市区"
                        clearable
                        @change="onAddrChange"
                    />
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="10">
                <el-form-item label="经度：" prop="">
                <el-input v-model="stationInfo.longitude" type="number" maxlength="100" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
            <el-col :span="10">
                <el-form-item label="纬度：" prop="" label-width='82'>
                <el-input v-model="stationInfo.latitude" type="number" maxlength="100" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
            <el-col :span="4">
                <el-button type="primary" @click="getLocationPoint">定位</el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-form-item label="详细地址：" prop="">
                    <el-input v-model="stationInfo.address" maxlength="100" autocomplete="off" :readonly="isReadonly"/>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <div id="baiduMapContainer" style="width: 100%; height: 300px; background-color: #f5f7fa;"></div>
        </el-row>
    </el-form>
        <template #footer>
        <div class="dialog-footer" v-show="!isReadonly">
            <el-button @click="closeAdd">取消</el-button>
            <el-button type="primary" @click="save()">确定</el-button>
        </div>
        </template>
    </el-drawer>

    <!-- 场站图片预览 -->
    <el-dialog v-model="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

    <!-- 场站监控 -->
    <el-drawer
        v-model="drawer2"
        title="场站实时监控数据大屏"
        size="100%"
        direction="ttb"
        @close="handleMonitorDrawerClose"
    >
    <template #header>
        <div style="width: 80%;">
            <div class="gun_station_name">场站名称：{{ monitorStationName }}</div>
            <div class="gun_station_nav">
                <div class="gun_status_nav">
                    <!-- <div class="gun_status_title">总终端数：{{ MoniTotal.terminals }}</div> -->
                    <div class="gun_status_total" :class="{ active: currentMonitorState === null }" style="background-color: rgb(24, 144, 255);" @click="handleMonitorStateChange(null)">全部终端：{{ MoniTotal.terminals }}</div>
                    <div class="gun_status_total" :class="{ active: currentMonitorState === 0 }" style="background-color: rgb(0, 192, 90);" @click="handleMonitorStateChange(0)">空闲：{{ MoniTotal.idle }}</div>
                    <div class="gun_status_total" :class="{ active: currentMonitorState === 1 }" style="background-color: rgb(65, 139, 248);" @click="handleMonitorStateChange(1)">充电中：{{ MoniTotal.charging }}</div>
                    <div class="gun_status_total" :class="{ active: currentMonitorState === 2 }" style="background-color: rgb(156, 119, 242);" @click="handleMonitorStateChange(2)">已插枪，未充电：{{ MoniTotal.insertion }}</div>
                    <div class="gun_status_total" :class="{ active: currentMonitorState === 3 }" style="background-color: rgb(254, 182, 38);" @click="handleMonitorStateChange(3)">故障：{{ MoniTotal.faults }}</div>
                    <div class="gun_status_total" :class="{ active: currentMonitorState === 4 }" style="background-color: rgb(153, 153, 153);" @click="handleMonitorStateChange(4)">离线：{{ MoniTotal.offline }}</div>
                </div>
            </div>
            <div class="gun_page_nav">
                <Pagination
                    v-model:current-page="currentPage2"
                    v-model:page-size="pageSize2"
                    :total="total2"
                    :page-sizes="[8, 16, 32, 64]"
                    @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                />
            </div>
        </div>
    </template>
    <div style="width: 100%;height: 100%;">
        <div class="gun_data_nav">
            <div class="gun_data_item" v-for="(item,index) in MonitorList" :key="item.id || index">
                <div class="gun_title">
                    <div class="gun_title_name">{{item.pileIndex}}号桩 {{item.gunIndex}}号枪</div>
                    <div class="gun_title_status" v-if="item.networkState==0">离线</div>
                    <div class="gun_title_status" v-else-if="item.networkState==1">{{workFilter(item.workState)}}</div>
                </div>
                <div class="gun_info">
                    <el-row class="gun_row">
                        <el-col :span="12">
                            <el-form-item label="车牌号：" prop="">
                                <div>{{item.licence?item.licence:'--'}}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="客户电话：" prop="">
                                <div>{{item.phone?item.phone:'--'}}</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="gun_row">
                        <el-col :span="24">
                            <el-form-item label="开始时间：" prop="">
                                <div>{{item.startTime?item.startTime:'--'}}</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="gun_row">
                        <el-col :span="24">
                            <el-form-item label="结束时间：" prop="">
                                <div>{{item.endTime?item.endTime:'--'}}</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="gun_row">
                        <el-col :span="12">
                            <el-form-item label="充电时长：" prop="">
                                <div>{{item.chargeTime?item.chargeTime+'分钟':'--'}}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="剩余时间：" prop="">
                                <div>{{item.remainTime?item.remainTime+'分钟':'--'}}</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="gun_row">
                        <el-col :span="12">
                            <el-form-item label="起始SOC：" prop="">
                                <div>{{item.startSOC?item.startSOC+'%':'--'}}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="当前SOC：" prop="">
                                <div>{{item.currentSOC?item.currentSOC+'%':'--'}}</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="gun_row">
                        <el-col :span="12">
                            <el-form-item label="电量：" prop="">
                                <div>{{item.electricity?item.electricity:'--'}}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="输出电压：" prop="">
                                <div>{{item.voltage?item.voltage+'V':'--'}}</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="gun_row">
                        <el-col :span="12">
                            <el-form-item label="输出电流：" prop="">
                                <div>{{item.current?item.current+'A':'--'}}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="输出功率：" prop="">
                                <div>{{item.power?item.power.toFixed(2)+'KW':'--'}}</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="gun_row">
                        <el-col :span="12">
                            <el-form-item label="电池最低温度：" prop="">
                                <div>{{item.minTemp?item.minTemp+'℃':'--'}}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="电池最高温度：" prop="">
                                <div>{{item.maxTemp?item.maxTemp+'℃':'--'}}</div>

                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="gun_row">
                        <el-col :span="12">
                            <el-form-item label="电池最低电压：" prop="">
                                <div>{{item.minVoltage?item.minVoltage+'V':'--'}}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="电池最高电压：" prop="">
                                <div>{{item.maxVoltage?item.maxVoltage+'V':'--'}}</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
    
    </el-drawer>

    <!-- 运营参数 -->
    <el-drawer
        v-model="drawer3"
        title="运营数据"
        direction="rtl"
        :before-close="handleClose"
    >
    <el-form :model="operationData" label-position="right" label-width="auto">
        <el-row>
            <el-col>
                <el-form-item label="场站名称：" >
                    <el-input v-model="operationData.name" maxlength="30" autocomplete="off" readonly="true" />
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-form-item label="分成模式：" prop="" >
                    <el-select v-model="operationData.splitMode" placeholder="请选择分成模式">
                        <el-option label="服务费" value="1" />
                        <el-option label="电量" value="2" />
                        <el-option label="分成比例" value="3" />
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-form-item label="电费差价：" prop="">
                <el-input v-model="operationData.electricityPriceDiff" type="number" autocomplete="off" />
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-form-item label="分成比例：" prop="">
                <el-input v-model="operationData.splitRatio" type="number" min="0" max="1" placeholder="请输入0~1之间的数字" autocomplete="off" />
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-form-item label="电量分成比例：" prop="">
                <el-input v-model="operationData.distributionRatio" type="number" min="0" max="1" placeholder="请输入0~1之间的数字" autocomplete="off" />
                </el-form-item>
            </el-col>
        </el-row>
       </el-form>
       <template #footer>
        <div class="dialog-footer">
            <el-button @click="closeAdd">取消</el-button>
            <el-button type="primary" @click="saveOp()">确定</el-button>
        </div>
        </template>
    </el-drawer>

    <!-- 详情 -->
    <el-dialog v-model="isReadonly" title="场站详情" width="900" :close-on-click-modal="false">
        <el-form :model="detailData" label-position="right" label-width="auto">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="场站名称：" prop="">
                        <div>{{detailData.name}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="简称：" prop="">
                        <div>
                        <span>{{detailData.shortName}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="场站编码：" prop="">
                        <div>{{detailData.code}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="运营状态：" prop="">
                        <div>
                        <span>{{statusFilter(detailData.state)}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="场站类型：" prop="">
                        <div>{{typeFilter(detailData.type)}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="省市区：" prop="">
                        <div>
                        <span>{{detailData.province}}{{detailData.city}}{{detailData.district}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="经度：" prop="">
                        <div>{{detailData.longitude}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="纬度：" prop="">
                        <div>
                        <span>{{detailData.latitude}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="详细地址：" prop="">
                        <div>
                        <span>{{detailData.address}}</span>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="场站电话：" prop="">
                        <div>
                        <span>{{detailData.stationPhone}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item label="场站照片：" prop="">
                        <div>
                            <el-image
                                v-for="(item, index) in detailImg"
                                :key="index"
                                :src="item"
                                style="width: 100px; height: 100px; margin-right: 10px;"
                            />
                        <!-- <img :src="detailData.stationImage.split(',')[0]" alt="" style="width: 100px;height: 100px;margin-right: 10px;"> -->
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="负责人：" prop="">
                        <div>{{detailData.stationManager}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="客服电话：" prop="">
                        <div>
                        <span>{{detailData.servicePhone}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="场站面积：" prop="">
                        <div>{{detailData.stationArea}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="场站总功率：" prop="">
                        <div>
                        <span>{{detailData.totalPower}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="开业时间：" prop="">
                        <div>{{detailData.openingTime}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="配套设施：" prop="">
                        <div>
                        <span>{{faFilter(detailData.facilities)}}</span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </el-dialog>

  </template>
  
<script>
import { defineComponent, onMounted, onBeforeUnmount, ref, watch } from 'vue'
import  { EluiChinaAreaDht }  from 'elui-china-area-dht'
import { ElMessage, ElMessageBox } from 'element-plus';
import axios from '@/config/axios'; // 引入封装的axios实例
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { useStore } from 'vuex';
import { nextTick } from 'vue';
import { required, isPhone, isNumber, isAlphanumeric, noSpecialChar } from '@/utils/validators';


const chinaData = new EluiChinaAreaDht.ChinaArea().chinaAreaflat;
// console.log('省市区数据:', chinaData); // 添加日志，确认数据是否正确加载
// 直辖市在区划数据中的市级占位名称（北京/天津/上海为"市辖区"，重庆分"市辖区"和"县"），天地图逆地理编码返回"直辖市"
const municipalityPlaceholders = ['市辖区', '直辖市', '县'];
// 直辖市市级占位名称归一为对应城市名称（即省名，如北京市）
const normalizeCityName = (province, city) => {
    if (!city || municipalityPlaceholders.indexOf(city) > -1) {
        return province || '';
    }
    return city;
};
// 构建省市区级联选项：直辖市的市级占位名称直接显示为对应城市名称
const buildAreaOptions = () => {
    const childrenMap = {};
    Object.values(chinaData).forEach(item => {
        if (!item.parent) return;
        if (!childrenMap[item.parent]) childrenMap[item.parent] = [];
        childrenMap[item.parent].push(item);
    });
    const provinces = Object.values(chinaData).filter(item => !item.parent);
    return provinces.map(province => {
        const pNode = { value: province.value, label: province.label, children: [] };
        (childrenMap[province.value] || []).forEach(city => {
            const cNode = {
                value: city.value,
                label: normalizeCityName(province.label, city.label),
                children: [],
            };
            (childrenMap[city.value] || []).forEach(district => {
                cNode.children.push({ value: district.value, label: district.label });
            });
            if (cNode.children.length > 0) {
                pNode.children.push(cNode);
            }
        });
        return pNode;
    });
};
const areaOptions = buildAreaOptions();
const cityOptions = [
    { value: '1', label: '休息室' }, 
    { value: '2', label: '洗手间' }, 
    { value: '3', label: '无线网络' }, 
    { value: '4', label: '便利店' }, 
    { value: '5', label: '餐饮' }, 
    { value: '6', label: '巡检机器人'},
    { value: '7', label: '有人值守' }, 
    { value: '8', label: '咖啡机' }, 
    { value: '9', label: '售卖机' }, 
    { value: '10', label: '雨棚' },
    { value: '11', label: '地锁' },
    { value: '12', label: '洗车' },
    { value: '13', label: '充电机器人' }
];
const baseURLDev = '/api';
const baseURL = process.env.VUE_APP_API_URL + '/';

export default defineComponent({
    name: 'StationManage',
    components: {
        EluiChinaAreaDht,
    },
    setup() {
        // 声明vuex对象
        const store = useStore();
        // 定义响应式数据
        const uploadUrl = ref(process.env.NODE_ENV === 'development' ? baseURLDev + store.state.platformApi + 'oss/upload' : baseURL + store.state.platformApi + 'oss/upload');
        const headers = ref({
            'Authorization': localStorage.getItem('token')
        });
        const dialogFormVisible = ref(false);
        const partnerInfo = ref({})
        const partnerList = ref([]);
        const searchPartners = ref([]);
        const selectedPartners = ref([]);
        const imgList = ref([]);  //场站图片列表
        const detailImg = ref([]); //详情图片列表
        const areaSelect = ref([]);
        const MoniTotal = ref({});  //监控终端统计
        const MoniData = ref([]);  //监控总数据
        const MonitorList = ref([]);  //监控列表数据
        const monitorStationName = ref('');  //监控场站名称
        const currentMonitorState = ref(null);  //监控状态筛选：0空闲 1充电中 2已插枪未充电 3故障 4离线
        const monitorStationId = ref('');  //当前监控场站ID
        const monitorTenantId = ref('');  //当前监控场站租户ID
        const checkAll = ref(false);
        const checkedCities = ref([]);
        const cities = ref(cityOptions);
        const isIndeterminate = ref(true);
        const dialogImageUrl = ref('');
        const dialogVisible = ref(false);
        const isReadonly = ref(false); 
        const detailData = ref({}); 
        const isUpdate = ref(false); 
        const drawerTitle = ref('新增场站'); 
        const drawer = ref(false); 
        const drawer2 = ref(false); 
        const drawer3 = ref(false); 
        const operationData = ref({ 
            id: '', 
            stationId: '', 
            name: '', 
            splitMode: '', 
            electricityPriceDiff: '', 
            splitRatio: '', 
            distributionRatio: '', 
        }); 
        const from_facilities = ref([]);
        const stationInfo = ref({
            addrCode: [], 
            id: '',
            name: '',  
            shortName: '', 
            code: '', 
            state: '',  
            type: '', 
            longitude: '', 
            latitude: '', 
            province: '', 
            provinceCode: '', 
            city: '', 
            cityCode: '', 
            district: '', 
            districtCode: '', 
            address: '', 
            stationImage: '', 
            stationManager: '', 
            stationPhone: '', 
            servicePhone: '', 
            totalPower: '', 
            buildingArea: '', 
            openingTime: '', 
            facilities: '', 
            mode: '',
            carNumber: '',
            upOrDown: '',
            constructionSite: '',
            evnType: '',
        });
        // 表单校验规则
        const stationFormRef = ref(null);
        const stationRules = {
            name: [required('请输入场站名称'), noSpecialChar('场站名称不能包含特殊字符')],
            shortName: [noSpecialChar('简称不能包含特殊字符')],
            code: [required('请输入场站编码'), isAlphanumeric('场站编码只能输入数字或字母')],
            servicePhone: [required('请输入联系电话'), isPhone('请输入正确的手机号或座机号')],
            stationManager: [noSpecialChar('场站负责人不能包含特殊字符')],
        };
        const tableData = ref([]);
        const total = ref(0); 
        const currentPage = ref(1); 
        const pageSize = ref(10); 
        const total2 = ref(0); 
        const currentPage2= ref(1); 
        const pageSize2 = ref(8); 
        const stationOptions = ref([{
            value: '1',
            label: '高速'
        }, {
            value: '2',
            label: '市区'
        }, {
            value: '3',
            label: '内部'
        }, {
            value: '4',
            label: '社区'
        }]);
        const statusOptions = ref([{
            value: '1',
            label: '建设中'
        }, {
            value: '2',
            label: '运营中'
        }, {
            value: '3',
            label: '未供电'
        }, {
            value: '4',
            label: '关闭下线'
        }]);
        const formInline = ref({
            type: '',
            state: '',
            provinceCode: '',
            cityCode: '',
            districtCode: '',
            partner: '',
            date: [],
            name: '',
        });

        let eventSource = null;
        let BDmap = null;
        let control = null;

        const initMap = () => {
            // 创建地图实例
            const map = new T.Map('baiduMapContainer');
            // 创建点坐标
            const point = new T.LngLat(113.46874237228292,23.131794661283873);
            // 初始化地图，设置中心点坐标和地图缩放级别
            map.centerAndZoom(point, 15);
            // 开启鼠标滚轮缩放
            map.enableScrollWheelZoom(true);

            //创建缩放平移控件对象
            control = new T.Control.Zoom();
            //添加缩放平移控件
            map.addControl(control);
            
            // 添加控件
            // map.addControl(new T.NavigationControl());
            
            // 添加标注
            const marker = new T.Marker(point);
            map.addOverLay(marker);
            
            // 添加点击事件
            map.addEventListener("click", addPoint);
            // marker.addEventListener('click', () => {
            //     const infoWindow = new T.InfoWindow('天安门');
            //     map.openInfoWindow(infoWindow, point);
            // });
            
            BDmap = map; // 保存实例以便其他地方使用
        }

        const initEditMap = () => {
            // 创建地图实例
            const map2 = new T.Map('baiduMapContainer');
            
            // 默认中心点（广州）
            let longitude = 113.46874237228292;
            let latitude = 23.131794661283873;
            
            // 如果有经纬度数据，使用数据的坐标
            if (stationInfo.value.longitude && stationInfo.value.latitude) {
                longitude = stationInfo.value.longitude;
                latitude = stationInfo.value.latitude;
            }
            
            const point2 = new T.LngLat(longitude, latitude);
            // 初始化地图，设置中心点坐标和地图缩放级别
            map2.centerAndZoom(point2, 15);
            // 开启鼠标滚轮缩放
            map2.enableScrollWheelZoom(true);
            
            // 添加缩放控件
            const editControl = new T.Control.Zoom();
            map2.addControl(editControl);
            
            // 如果有经纬度数据，添加标注
            if (stationInfo.value.longitude && stationInfo.value.latitude) {
                const marker = new T.Marker(point2);
                map2.addOverLay(marker);
            }
            
            // 添加点击事件
            map2.addEventListener("click", addPoint);
            
            BDmap = map2; // 保存实例以便其他地方使用
        }

        const addPoint = (e) => {
            // console.log('点击事件--:',e);
            showAddressOfPoint(e.lnglat, true);
        };

        const showAddressOfPoint = (point, isShow) => {
            deleteAllPoints();
            BDmap.centerAndZoom(point, 15);
	        addOverLayAtPoint(point);
            getAddressByPoint(point, function (addressObj) {
                // console.log('地址信息:',addressObj);
                applyMapAddress(addressObj);
            });
        };

        const addOverLayAtPoint = (point) => {
            if (!BDmap) return;
            const marker = new T.Marker(point);
            BDmap.addOverLay(marker);
        }

        const deleteAllPoints = () => {
            if (!BDmap) return;
            BDmap.clearOverLays();
        }

        const getAddressByPoint = (point, callback) => {
            const geocoder = new T.Geocoder();
            geocoder.getLocation(point, function (rs) {
                console.log('天地图返回的完整地址数据:', rs);
                if(rs.location){
                    stationInfo.value.longitude = rs.location.lon;
                    stationInfo.value.latitude = rs.location.lat;
                }
                if (rs.addressComponent) {
                    const address = rs.formatted_address;
                    // 处理city字段：天地图可能返回city为空，需要从其他字段获取
                    let city = rs.addressComponent.city;
                    if (!city || city === '') {
                        // 如果city为空，尝试从province或district获取
                        city = rs.addressComponent.province || '';
                    }
                    callback({
                        address: address,
                        province: rs.addressComponent.province,
                        city: city,
                        district: rs.addressComponent.county,
                        street: rs.addressComponent.town,
                        streetNumber: rs.addressComponent.town_code,
                    });
                } else {
                    callback(null);
                }
            });
        };

        // 根据省市区名称在行政区划数据中反查区划代码（按 parent 层级匹配；直辖市级名称为占位或省名时，按区县归属定位市级节点）
        const resolveAreaCodes = (province, city, district) => {
            const codes = { provinceCode: '', cityCode: '', districtCode: '' };
            if (!province) return codes;
            const entries = Object.values(chinaData);
            const provinceEntry = entries.find(item => item.label === province && !item.parent);
            if (!provinceEntry) return codes;
            codes.provinceCode = String(provinceEntry.value);
            const cityEntries = entries.filter(item => item.parent === provinceEntry.value);
            const cityName = normalizeCityName(province, city);
            let cityEntry = cityEntries.find(item => item.label === cityName);
            if (!cityEntry) {
                // 直辖市（如天地图返回"直辖市"）等城市名与市级占位名称不一致时，优先按区县归属定位市级节点
                cityEntry = district
                    ? cityEntries.find(item => entries.some(d => d.parent === item.value && d.label === district))
                    : null;
                if (!cityEntry && cityEntries.length > 0) cityEntry = cityEntries[0];
            }
            if (!cityEntry) return codes;
            codes.cityCode = String(cityEntry.value);
            if (district) {
                const districtEntry = entries.find(item => item.parent === cityEntry.value && item.label === district);
                if (districtEntry) codes.districtCode = String(districtEntry.value);
            }
            return codes;
        };

        // 用天地图逆地理编码结果回填省市区名称及区划代码，配合手动省市区选择器使用
        const applyMapAddress = (addressObj) => {
            if (!addressObj) return;
            stationInfo.value.province = addressObj.province || '';
            // 天地图对直辖市返回的 city 是"直辖市"占位名称，归一为对应城市名称
            stationInfo.value.city = normalizeCityName(addressObj.province || '', addressObj.city || '');
            stationInfo.value.district = addressObj.district || '';
            stationInfo.value.address = addressObj.address || '';
            const codes = resolveAreaCodes(stationInfo.value.province, stationInfo.value.city, stationInfo.value.district);
            stationInfo.value.provinceCode = codes.provinceCode;
            stationInfo.value.cityCode = codes.cityCode;
            stationInfo.value.districtCode = codes.districtCode;
            // 区划代码齐全时同步省市区选择器回显，否则置空由用户手动选择
            if (codes.provinceCode && codes.cityCode && codes.districtCode) {
                stationInfo.value.addrCode = [codes.provinceCode, codes.cityCode, codes.districtCode];
            } else {
                stationInfo.value.addrCode = [];
            }
        };

        // 省市区选择器变更：按选中节点赋值省市区名称及区划编码
        const onAddrChange = (e) => {
            if (!e || e.length < 2) {
                stationInfo.value.province = '';
                stationInfo.value.provinceCode = '';
                stationInfo.value.city = '';
                stationInfo.value.cityCode = '';
                stationInfo.value.district = '';
                stationInfo.value.districtCode = '';
                return;
            }
            const one = chinaData[e[0]];
            const two = chinaData[e[1]];
            const three = e.length > 2 ? chinaData[e[2]] : null;
            stationInfo.value.province = one.label;
            stationInfo.value.provinceCode = one.value;
            stationInfo.value.city = normalizeCityName(one.label, two.label);
            stationInfo.value.cityCode = two.value;
            stationInfo.value.district = three ? three.label : '';
            stationInfo.value.districtCode = three ? three.value : '';
        };

        const getLocationPoint = () => {
            if(stationInfo.value.longitude && stationInfo.value.latitude){
                const point = new T.LngLat(stationInfo.value.longitude, stationInfo.value.latitude);
                // console.log('定位事件--:',point);
                localStorage.setItem('ycy-locationPoint', JSON.stringify(point));
                showAddressOfPoint(point, true);
            }else{
                ElMessage.error('请先输入经纬度');
            }
        }

        const showDialogForm = (index, row) => {
            dialogFormVisible.value = true;
            operationData.value.stationId = row.id;
            selectedPartners.value = row.stationPartners.map(item => item.id);
        }

        const handleAvatarSuccess = (res, file) => {
            // console.log('上传成功',res);
            imgList.value.push({
                url: res.data.url,
            });
            // console.log(file);
        };
        const beforeAvatarUpload = (file) => {
            console.log(file);
            return true;
        }

        const handleSizeChange = (val) => { 
            pageSize.value = val;
            currentPage.value = 1;
            getList();
        };

        const handleCurrentChange = (val) => { 
            currentPage.value = val;
            getList(); 
        };

        const handleSizeChange2 = (val) => { 
            pageSize2.value = val;
            currentPage2.value = 1;
        };

        const handleCurrentChange2 = (val) => { 
            //监控
            currentPage2.value = val;
        };

        const handleCheckedCitiesChange = (value) => {
            let checkedCount = value.length;
            checkAll.value = checkedCount === cities.value.length;
            isIndeterminate.value = checkedCount > 0 && checkedCount < cities.value.length;
        };

        const handleRemove = (file, fileList) => {
            // console.log(file, fileList);
            imgList.value = imgList.value.filter((item) => item.url !== file.url);
        };

        const handlePictureCardPreview = (file) => {
            dialogImageUrl.value = file.url;
            dialogVisible.value = true;
        };

        // const openVCR = (index, row) => {
        //     axios.post("platform-server/station/monitor/" + row.id).then(result => {
        //         if(result.code === 200){
        //             drawer2.value = true;
        //         }else{
        //             ElMessage({
        //                 message: result.message,
        //                 type: 'error',
        //             });
        //         }
        //     });
        // };

        const exportData = () => {
            axios.post(store.state.platformApi + "station/export", {}, {responseType: 'blob'}).then(result => {
                // console.log(result);
            });
        };

        const openAdd = () => {
            isReadonly.value = false; 
            isUpdate.value = false; 
            imgList.value = [];
            Object.keys(stationInfo.value).forEach(key => {
                if (key === 'addrCode') {
                    stationInfo.value[key] = [];
                } else if (key === 'facilities') {
                    from_facilities.value = [];
                } else {
                    stationInfo.value[key] = '';
                }
            });
            drawerTitle.value = '新增场站'; 
            drawer.value = true;
            nextTick(() => {
                stationFormRef.value?.clearValidate();
            });
            // 使用 nextTick 等待 DOM 渲染完成后再初始化地图
            nextTick(() => {
                initMap();
            });
        };

        const openOperation = (index, row) => {
            operationData.value.stationId = row.id;
            operationData.value.name = row.name;
            axios.post(store.state.platformApi + "operation/params/view/" + row.id).then(result => {
                if(result.code === 200){
                    if(result.data){
                        operationData.value.id = result.data.id;
                        operationData.value.stationId = result.data.stationId;
                        operationData.value.distributionRatio = result.data.distributionRatio;
                        operationData.value.electricityPriceDiff = result.data.electricityPriceDiff;
                        operationData.value.splitRatio = result.data.splitRatio;
                        operationData.value.splitMode = result.data.splitMode;
                    } else {
                        Object.keys(operationData.value).forEach(key => {
                            if (key !== 'stationId' && key !== 'name') {
                                operationData.value[key] = ''; 
                            }
                        });
                    }
                    drawer3.value = true;
                } else {
                    ElMessage({
                        message: result.message,
                        type: 'error',
                    });
                }
            });
        };

        const closeAdd = () => {
            if (isReadonly.value) {
                drawer.value = false;
                drawer3.value = false;
            } else {
                ElMessageBox.confirm ('此操作不会保存更改哦，确定关闭吗？', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
                .then(() => {
                    drawer.value = false;
                    drawer3.value = false;
                })
                .catch(() => {});
            }
        };

        const handleClose = (done) => {
            if (isReadonly.value) {
                done();
            } else {
                ElMessageBox.confirm ('此操作不会保存更改哦，确定关闭吗？', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
                .then(() => {
                    done();
                })
                .catch(() => {});
            }
        };

        const getList = () => {
            let param = {
                page: currentPage.value,
                pageSize: pageSize.value,
                name: formInline.value.name,
                type: formInline.value.type,
                envType: formInline.value.envType,
                start: formInline.value.date? formInline.value.date[0] : '',
                end: formInline.value.date? formInline.value.date[1] : '',
                partnerIds: searchPartners.value,
                state: formInline.value.state,
                provinceCode: formInline.value.provinceCode,
                cityCode: formInline.value.cityCode,
                districtCode: formInline.value.districtCode,
            };
            axios.post(store.state.platformApi + "station/page", JSON.stringify(param)).then(result => {
                if(result.code === 200){
                    tableData.value = result.data.records; 
                    total.value = result.data.total;
                }
            });
        };

        const getPartnerList = () => {
            let param = {};
            axios.post(store.state.platformApi + "partner/list", JSON.stringify(param)).then(result => {
                if(result.code === 200){
                    result.data.forEach(item => {
                        let item_obj = {};
                        item_obj.label = item.name;
                        item_obj.value = item.id;
                        partnerList.value.push(item_obj);
                    });
                }
            });
        };

        const saveConfig = () => {
            let url = store.state.platformApi + "station/partner/config";
            let param = {
                stationId: operationData.value.stationId,
                partnerIds: selectedPartners.value,
            };
            axios.post(url, JSON.stringify(param)).then(result => {
                if(result.code === 200){
                    dialogFormVisible.value = false;
                    getList();
                    ElMessage({
                        message: '保存成功',
                        type: 'success',
                    });
                } else {
                    ElMessage({
                        message: result.message,
                        type: 'error',
                    });
                }
            });
        };

        const save = () => {
            // 先进行表单校验
            stationFormRef.value.validate((valid) => {
                if (!valid) return;
                
                // 如果有经纬度但城市字段为空，先获取地址信息
                if (stationInfo.value.longitude && stationInfo.value.latitude && !stationInfo.value.city) {
                    const point = new T.LngLat(stationInfo.value.longitude, stationInfo.value.latitude);
                    getAddressByPoint(point, function (addressObj) {
                        applyMapAddress(addressObj);
                        doSave();
                    });
                } else {
                    doSave();
                }
            });
        };

        const doSave = () => {
            let url = isUpdate.value ? store.state.platformApi + "station/edit" : store.state.platformApi + "station/add";
            if (from_facilities.value.length > 0) {
                stationInfo.value.facilities = from_facilities.value.join(','); 
            } else {
                stationInfo.value.facilities = '';
            }
            stationInfo.value.stationImage = imgList.value.map(item => item.url).join(',');
            axios.post(url, JSON.stringify(stationInfo.value)).then(result => {
                if(result.code === 200){
                    drawer.value = false;
                    getList();
                    ElMessage({
                        message: '保存成功',
                        type: 'success',
                    });
                }
            });
        };

        const setInfo = (dataInfo) => {
            Object.keys(stationInfo.value).forEach(key => {
                if (key !== 'addrCode') {
                    stationInfo.value[key] = dataInfo[key]; 
                }
            });

            if (dataInfo.longitude && dataInfo.latitude) {
                let point_data = {
                    longitude: dataInfo.longitude,
                    latitude: dataInfo.latitude,
                }
                localStorage.setItem('ycy-locationPoint', JSON.stringify(point_data));
            }
            
            stationInfo.value.addrCode = [];
            if (dataInfo.provinceCode) {
                stationInfo.value.addrCode.push(dataInfo.provinceCode);
                stationInfo.value.addrCode.push(dataInfo.cityCode);
                stationInfo.value.addrCode.push(dataInfo.districtCode);
            }

            if (dataInfo.facilities) {
                from_facilities.value = dataInfo.facilities.split(',');
            } else {
                from_facilities.value = [];  
            }
            if (dataInfo.stationImage) {
                imgList.value = dataInfo.stationImage.split(',').map(item => ({
                    url: item,
                }));
            } else {
                imgList.value = [];
            }
            // console.log('setInfo',stationInfo.value);
        };

        const handleEdit = (index, row) => {
            isReadonly.value = false; 
            isUpdate.value = true; 
            drawerTitle.value = '编辑场站'; 
            setInfo(row);
            drawer.value = true;
            nextTick(() => {
                initEditMap();
            });
        };

        const showInfo = (index, row) => {
            drawerTitle.value = '场站详情'; 
            isReadonly.value = true;
            isUpdate.value = false; 
            detailData.value = row;
            if (detailData.value.stationImage) {
                detailImg.value = detailData.value.stationImage.split(',');
            } else {
                detailImg.value = [];
            }
        };

        const saveOp = () => {
            let url = store.state.platformApi + "operation/params/edit";
            axios.post(url, JSON.stringify(operationData.value)).then(result => {
                if(result.code === 200){
                    drawer3.value = false;
                    ElMessage({
                        message: '保存成功',
                        type: 'success',
                    });
                }
            });
        };

        const onChange = (e) => {
            if(e[0]=='all'){
                formInline.value.provinceCode = '';
                formInline.value.cityCode = '';
                formInline.value.districtCode = '';
            }else if(e[1]=='all'){
                formInline.value.provinceCode = e[0];
                formInline.value.cityCode = '';
                formInline.value.districtCode = '';
            }else if(e[2]=='all'){
                formInline.value.provinceCode = e[0];
                formInline.value.cityCode = e[1];
                formInline.value.districtCode = '';
            }else{
                let one = chinaData[e[0]];
                let two = chinaData[e[1]];
                let three = chinaData[e[2]];
                formInline.value.provinceCode = one.value;
                formInline.value.cityCode = two.value;
                formInline.value.districtCode = three.value;
            }
        };

        const deleteStation = (index, row) => {
            ElMessageBox.confirm ('确定删除该场站吗？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            })
            .then(() => {
                axios.post(store.state.platformApi + "station/delete/" + row.id).then(result => {
                    if(result.code === 200){
                        getList();
                        ElMessage({
                            message: '已删除场站',
                            type: 'success',
                        });
                    }
                });
            })
            .catch(() => {
                // console.log('已取消-----');
            });
        };

        // 监听 currentPage2 和 pageSize2 的变化
        watch([currentPage2, pageSize2], ([newCurrentPage2, newPageSize2], [oldCurrentPage2, oldPageSize2]) => {
            MonitorList.value = MoniData.value.slice((newCurrentPage2 - 1) * newPageSize2, newCurrentPage2 * newPageSize2);
        });
        // 初始化监控列表数据
        const getMoniData = (index, row) => {
            monitorStationName.value = row.name;
            monitorStationId.value = row.id;
            monitorTenantId.value = row.tenantId;
            currentMonitorState.value = null;
            currentPage2.value = 1;
            fetchMonitorData(row.id, row.tenantId, null);
        };

        // 请求监控数据（sse/init）
        const fetchMonitorData = (stationId, tenantId, monitorState) => {
            axios.post(store.state.platformApi + "sse/init", {
                stationId: stationId,
                tenantId: tenantId,
                monitorState: monitorState
            }).then(result => {
                if(result.code === 200){
                    if(!result.data){
                        ElMessage({
                            message: '当前场站未开启监控',
                            type: 'warning',
                        });
                        return;
                    }
                    MoniTotal.value = result.data;
                    MoniData.value = result.data.gunsInfo;
                    total2.value = MoniData.value.length;
                    currentPage2.value = 1;
                    MonitorList.value = MoniData.value.slice((currentPage2.value - 1) * pageSize2.value, currentPage2.value * pageSize2.value);
                    drawer2.value = true;
                    setupSSEConnection();
                }
            });
        };

        // 切换监控状态筛选
        const handleMonitorStateChange = (state) => {
            if(currentMonitorState.value === state){
                // 再次点击同一状态，取消筛选，查全部
                currentMonitorState.value = null;
            } else {
                currentMonitorState.value = state;
            }
            // 关闭旧 SSE 连接
            if (eventSource) {
                eventSource.abort();
                eventSource = null;
            }
            fetchMonitorData(monitorStationId.value, monitorTenantId.value, currentMonitorState.value);
        };

        // 关闭监控抽屉
        const handleMonitorDrawerClose = () => {
            currentMonitorState.value = null;
            if (eventSource) {
                eventSource.abort();
                eventSource = null;
            }
        };

        const setupSSEConnection = () => {
            // chargeAmount: 0
            // current: 0
            // electricity: 0
            // endSoc: 0
            // endTime: "2025-06-30 16:15:29"
            // gunIndex: 1
            // maxTemp: 0
            // maxVoltage: 0
            // minTemp: 0
            // minVoltage: 0
            // pileIndex: 1
            // power: 0
            // remainTime: 0
            // voltage: 2172
            // MoniData.value = [
            //     {
            //         name: '测试1',
            //     },
            //     {
            //         name: '测试2',
            //     },
            //     {
            //         name: '测试3',
            //     },
            //     {
            //         name: '测试4',
            //     },
            //     {
            //         name: '测试5',
            //     },
            //     {
            //         name: '测试6',
            //     },
            //     {
            //         name: '测试7',
            //     },
            //     {
            //         name: '测试8',
            //     },
            //     {
            //         name: '测试9',
            //     },
            //     {
            //         name: '测试10',
            //     },
            //     {
            //         name: '测试11',
            //     },
            //     {
            //         name: '测试12',
            //     },
            // ];
            // MonitorList.value = MoniData.value.slice(0, 5);
            // total2.value = MoniData.value.length;
            // MonitorList.value = MoniData.value.slice((currentPage2.value - 1) * pageSize2.value, currentPage2.value * pageSize2.value);
            // console.log(MoniData.value);
            // myTimer = setInterval(() => {
            //     console.log('setInterval---111');
            // }, 2000);

            // 返回数据格式
//             event:data:
            // data:{"charging":1,
            // "faults":0,
            // "gunsInfo":[{
            //     "chargeAmount":0.0,
            //     "chargeTime":0,
            //     "current":0.0,
            //     "electricity":0.0,
            //     "endSoc":0.0,
            //     "endTime":"2025-07-01 17:35:41",
            //     "gunIndex":1,
            //     "maxTemp":0.0,
            //     "maxVoltage":0.0,
            //     "minTemp":0.0,
            //     "minVoltage":0.0,
            //     "phone":"18826270203",
            //     "pileIndex":1,
            //     "power":0.0,
            //     "remainTime":0,
            //     "startSoc":0.0,
            //     "startTime":"2025-07-01 17:35:26",
            //     "voltage":221.1},
            //     {"gunIndex":1,"pileIndex":2}
            // ],
            // "idle":0,
            // "insertion":1,
            // "offline":1,
            // "terminals":2
            // }

            
            let token = localStorage.getItem('token');
            eventSource = new AbortController();

            let sseUrl = `sse/pile/${monitorTenantId.value}/${monitorStationId.value}`;
            fetchEventSource(process.env.NODE_ENV === 'development' ? baseURLDev + store.state.platformApi + sseUrl : baseURL + store.state.platformApi + sseUrl, {
                signal: eventSource.signal,
                headers: {
                    'content-type': 'text/event-stream',
                    'Cache-Control': 'no-cache',
                    'Authorization': token, // 可自定义请求头
                },
                openWhenHidden: true,  // 保持后台连接
                onopen(res) {
                    if (res.ok) console.log("SSE 连接成功");
                    else console.error("SSE 连接失败");
                },
                onmessage(event) {
                    // console.log("收到消息:", event.data); // 确保这里被调用
                    let data = JSON.parse(event.data);
                    // console.log(data);
                    // 判断是否为当前场站的数据，不是则忽略
                    if(data.stationId && data.stationId !== monitorStationId.value) return;
                    if(data.gunsInfo){
                        MoniTotal.value = data;
                        MoniData.value = data.gunsInfo;
                        total2.value = MoniData.value.length;
                        MonitorList.value = MoniData.value.slice((currentPage2.value - 1) * pageSize2.value, currentPage2.value * pageSize2.value);
                    }
                },
                onerror(err) {
                    console.error("SSE 错误:", err);
                    setTimeout(() => setupSSEConnection, 5000);
                },
            });
        };

        onMounted(() => {
            getList(); 
            getPartnerList();
            // setupSSEConnection();
        });

        onBeforeUnmount(() => {
            // 离开页面，关闭SSE连接
            if (eventSource) {
                eventSource.abort();
                eventSource = null;
            }
        });

        const faFilter = (value) => {
            let arr = value.split(',');
            let str = '';
            arr.forEach(item => {
                if (item === '1') {
                    str += '休息室,';
                } else if (item === '2') {
                    str += '洗手间,';
                } else if (item === '3') {
                    str += '无线网络,';
                } else if (item === '4') {
                    str += '便利店,';
                } else if (item === '5') {
                    str += '餐饮,';
                } else if (item === '6') {
                    str += '巡检机器人,';
                } else {
                    str += '其他,';
                }
            });
            return str;
        }; 

        const typeFilter = (value) => {
            if (value === 1) {
                return '高速';
            } else if (value === 2) {
                return '市区';
            } else if (value === 3) {
                return '内部';
            } else if (value === 4) {
                return '社区';
            } else {
                return '其他';
            }
        }; 

        const statusFilter = (value) => {
            if (value === 1) {
                return '建设中';
            } else if (value === 2) {
                return '运营中';
            } else if (value === 3) {
                return '未供电';
            } else if (value === 4) {
                return '关闭下线';
            } else {
                return '其他';
            }
        };

        const partnerFilter = (value) => {
            if (value) {
                return value.map(item => item.name).join(',');
            } else {
                return '--';
            }
        };

        const showFilter = (value) => {
            if (value === '1') {
                return '可见可用';
            } else if (value === '2') {
                return '可见不可用';
            } else if (value === '3') {
                return '不可见不可用';
            }
        };

        const workFilter = (value) => {
            if (value === 0) {
                return '空闲';
            } else if (value === 1) {
                return '充电';
            } else if (value === 2) {
                return '故障';
            } else if (value === 3) {
                return '被禁用';
            } else if (value === 4) {
                return '排队中';
            } else if (value === 5) {
                return '被预约';
            } else if (value === 6) {
                return '离线';
            } else {
                return '其他';
            }
        };

        return {
            MoniData,
            MoniTotal,
            MonitorList,
            monitorStationName,
            currentMonitorState,
            checkAll,
            checkedCities,
            cities,
            isIndeterminate,
            dialogImageUrl,
            dialogVisible,
            isReadonly,
            detailData,
            isUpdate,
            drawerTitle,
            drawer,
            drawer2,
            drawer3,
            operationData,
            from_facilities,
            stationInfo,
            stationFormRef,
            stationRules,
            tableData,
            total,
            currentPage,
            pageSize,
            total2,
            currentPage2,
            pageSize2,
            stationOptions,
            statusOptions,
            formInline,
            areaSelect,
            areaOptions,
            uploadUrl,
            headers,
            dialogFormVisible,
            partnerInfo,
            partnerList,
            searchPartners,
            selectedPartners,
            imgList,
            detailImg,
            showDialogForm,
            handleAvatarSuccess,
            beforeAvatarUpload,
            handleSizeChange,
            handleCurrentChange,
            handleSizeChange2,
            handleCurrentChange2,
            handleCheckedCitiesChange,
            handleRemove,
            handlePictureCardPreview,
            exportData,
            openAdd,
            openOperation,
            closeAdd,
            handleClose,
            initMap,
            initEditMap,
            addPoint,
            deleteAllPoints,
            showAddressOfPoint,
            addOverLayAtPoint,
            getAddressByPoint,
            getLocationPoint,
            getList,
            getPartnerList,
            saveConfig,
            getMoniData,
            handleMonitorStateChange,
            handleMonitorDrawerClose,
            save,
            setInfo,
            handleEdit,
            showInfo,
            saveOp,
            onChange,
            onAddrChange,
            deleteStation,
            faFilter,
            typeFilter,
            statusFilter,
            partnerFilter,
            showFilter,
            workFilter
        };
    }
});
</script>

<style lang="scss" scoped>
.search_nav{
    width: 100%;
    height: 60px;
}
.gun_station_name{
    width: 90%;
    font-size: 20px;
    font-weight: bold;
}
.gun_station_nav{
    width: 90%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
    .gun_status_nav{
       display: flex;
       align-items: center;
       .gun_status_title{
           width: 180px;
           font-size: 14px;
           font-weight: bold;
           margin-right: 20px;
       }
       .gun_status_total{
           width: 150px;
           height: 40px;
           line-height: 40px;
           color: #fff;
           border-radius: 5px;
           text-align: center;
           font-size: 14px;
           margin-right: 20px;
           cursor: pointer;
           transition: opacity 0.2s, box-shadow 0.2s;
           opacity: 0.85;
       }
       .gun_status_total:hover{
           opacity: 1;
       }
       .gun_status_total.active{
           opacity: 1;
           box-shadow: 0 0 0 2px rgba(255,255,255,0.8) inset;
           font-weight: bold;
       }
    }
}
.gun_page_nav{
    width: 90%;
    // display: flex;
    // justify-content: flex-end;
    // align-items: center;
    padding-top: 20px;
}
.gun_data_nav{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding: 16px;
    box-sizing: border-box;
    .gun_data_item{
        width: calc(25% - 12px);
        height: 400px;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
        overflow: hidden;
        background: #fff;
        transition: box-shadow 0.3s;
   }
   .gun_data_item:hover{
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
   }
   .gun_title{
        font-size: 16px;
        font-weight: bold;
        padding: 16px 20px;
        background-color: #73a9e3;
        position: relative;
        border-radius: 8px 8px 0 0;
        color: #fff;
   }
   .gun_title_name{
        font-size: 16px;
        font-weight: bold;
   }
   .gun_title_status{
        font-size: 14px;
        font-weight: bold;
        color: #fff;
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        right: 20px;
        width: 50px;
        height: 20px;
   }
   .gun_info{
        padding: 16px 20px;
   }
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
     background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6;
  }
  .gun_row{
    height: 30px;
  }
  
  .elui-china-area-dht {
  display: block !important; /* 强制显示 */
  visibility: visible !important; /* 确保可见 */
  .elui-china-area-dht__area {
    display: block;
    width: 100%;
    min-height: 30px; /* 设置最小高度 */
  }
}
</style>